var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSetting = function SvgSetting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-dark-blue7)",
    strokeWidth: 1.5,
    d: "m10.31 2.757-.198.797a1 1 0 0 1-.523.652l-1.187.593a1 1 0 0 1-.819.034l-1.47-.588a1 1 0 0 0-1.08.221l-.48.482a1 1 0 0 0-.151 1.222l.816 1.36a1 1 0 0 1 .037.961l-.536 1.072a1 1 0 0 1-.699.533l-1.216.243a1 1 0 0 0-.804.98v.861a1 1 0 0 0 .804.98l1.165.234a1 1 0 0 1 .732.609l.59 1.475a1 1 0 0 1-.128.972l-.643.856a1 1 0 0 0 .093 1.307l.774.774a1 1 0 0 0 1.307.093l.812-.61a1 1 0 0 1 1.047-.094l1.01.505a1 1 0 0 1 .533.699l.243 1.216a1 1 0 0 0 .98.804h1.361a1 1 0 0 0 .98-.804l.244-1.216a1 1 0 0 1 .533-.699l1.01-.505a1 1 0 0 1 1.047.095l.812.609a1 1 0 0 0 1.307-.093l.774-.774a1 1 0 0 0 .093-1.307l-.61-.812a1 1 0 0 1-.094-1.047l.505-1.01a1 1 0 0 1 .699-.533l1.216-.243a1 1 0 0 0 .804-.98V11.32a1 1 0 0 0-.804-.98l-1.216-.244a1 1 0 0 1-.699-.533l-.505-1.01a1 1 0 0 1 .095-1.047l.609-.812a1 1 0 0 0-.093-1.307l-.877-.877a1 1 0 0 0-1.155-.188l-.908.454a1 1 0 0 1-.894 0l-1.142-.57a1 1 0 0 1-.523-.652l-.199-.797A1 1 0 0 0 12.72 2h-1.438a1 1 0 0 0-.97.757Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4.25,
    stroke: "var(--c-dark-blue7)",
    strokeWidth: 1.5
  })));
};
export default SvgSetting;